const huygens = {
  brand: "#E07A5F",
  primary: "#0F2836",
  secondary: "#E07A5F",
  link: "#BEBB9B",
  hover: "#E07A5F"
};

const dordrecht5D = {
  brand: "#5b9cab",
  primary: "#358597",
  secondary: "#F4A896",
  link: "#358597",
  hover: "#e3b2b2"
};

const canals5D = {
  brand: "#C09939",
  primary: "#C09939",
  secondary: "#23354E",
  link: "#23354E",
  hover: "#FFFFFF"
};

export { huygens, dordrecht5D, canals5D };
